import script from "./StreamsManageNotifications.vue?vue&type=script&setup=true&lang=js"
export * from "./StreamsManageNotifications.vue?vue&type=script&setup=true&lang=js"

import "./StreamsManageNotifications.vue?vue&type=style&index=0&id=4e52e87c&lang=css"

const __exports__ = script;

export default __exports__